export const CURRENCY_CODE = 'BDT';
export const CURRENCY_SYMBOL = '৳';

export const formatCurrency = (value) =>
  `${CURRENCY_SYMBOL}${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })}`;
